import { IRequest } from '@r1-frontend/shared/types/IRequest';

import { PackageLine, ResponseDto } from './dto/ResponseDto';

const getPackageLines = (aliases?: string[]): IRequest => {
    let uri = 'v1/web/lines';
    const searchParams = new URLSearchParams();

    if (aliases) {
        aliases.forEach(alias => {
            searchParams.append('alias', alias);
        });

        uri += `?${searchParams.toString()}`;
    }

    return {
        uri,
        method: 'GET',
        withProvider: true,
    };
};

export default getPackageLines;

export type {
    PackageLine,
    ResponseDto,
};
